import React, { useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import { useAuth } from '../hooks/useAuth';
import './AuthPages.css';

/**
 * Page de connexion
 */
const LoginPage: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Récupérer l'URL de redirection depuis les paramètres ou l'état de l'emplacement
  const from = location.state?.from?.pathname || '/';
  
  // Rediriger si l'utilisateur est déjà connecté
  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, from]);
  
  // Callback après connexion réussie
  const handleLoginSuccess = () => {
    navigate(from, { replace: true });
  };
  
  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <h1>EtuDown</h1>
          <p className="auth-subtitle">Connectez-vous pour accéder à votre compte</p>
        </div>
        
        <LoginForm onSuccess={handleLoginSuccess} />
        
        <div className="auth-footer">
          <p>
            Vous n'avez pas de compte ?{' '}
            <Link to="/register" className="auth-link">
              Inscrivez-vous
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
